module.exports = __webpack_public_path__ + "static/img/station3.23f06d38.png";